/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Emptystate_Title3Inputs */

const en_settings_reportingapikeys_emptystate_title3 = /** @type {(inputs: Settings_Reportingapikeys_Emptystate_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API keys yet`)
};

/**
* | output |
* | --- |
* | "No API keys yet" |
*
* @param {Settings_Reportingapikeys_Emptystate_Title3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_emptystate_title3 = /** @type {((inputs?: Settings_Reportingapikeys_Emptystate_Title3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Emptystate_Title3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_emptystate_title3(inputs)
});
export { settings_reportingapikeys_emptystate_title3 as "settings_reportingApiKeys_emptyState_title" }